export default __webpack_public_path__ + "static/media/gravity.ef5d794f.png";